export let SaleTypes = /*#__PURE__*/function (SaleTypes) {
  SaleTypes["Seasonal"] = "Seasonal";
  return SaleTypes;
}({});
export const SaleTypesPercentsAmount = {
  [SaleTypes.Seasonal]: 50
};
//# sourceMappingURL=sale-types.enum.js.map